// Modulo de busqueda de sku's
import React , { useState }from 'react'


import Form from 'react-bootstrap/Form';

import {faMagnifyingGlass} from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown'

import axios from 'axios';
//import getGlobal from '../../setglobal';
import SearchDrop from './SearchDrop';


export default function Search({show ,setClaveProd,setText}) {

    const [showDrop,setShowDrop] = useState( false ) ;
    const [myData, setMyData] = useState( []) ;


    function setClave( value )
    {
        console.log( "Value = " + value ) ;

        setClaveProd( value ) ; 
    }

    function onSearchSku(e)
    {
        e.preventDefault() ;

        var sku = document.getElementById( 'buscar').value ;
        console.log( "Nos mandan a buscar " + sku ) ;


        var prodList = sku.split( " ") ;

        axios.get(  "http://localhost:3004/livefactura/getprodserv?parms=" + prodList )
        .then( (response) => {


            console.log( "Aqui tenemos la respuesta") ;

            console.log( response.data ) ;

            setMyData( response.data ) ;
            if ( response.data.length > 0 )
            {
                setShowDrop( true ) ;
            }
            else{
                setShowDrop ( false ) ;
            }
            

        } ) 
        .catch( ( err ) => {

            console.log( "Tenemos un error")
            console.log( err ) ;
        })





        
    }

    function onChangeSku( e )
    {


        return ; // No lo hacemos en tiempo real
        

    }

  return (

    //<div>Hola amigo</div>

    <div className='search' id="searchform">
        
        <div className='row pt-2 '>
            <div className='col-4'></div>
            <div className='col-4'>
                <div style={{display:'flex' ,position:'relative'}}>
                    <Form.Control style={{display:'inline'}}
                        type="text"
                        id="buscar"
                        aria-describedby="buscarBlock"
                        placeholder='Clave Producto Servicio'
                        height={20}
                        onChange={onChangeSku}
                        
                    />
                    <Form.Text id="buscarBlock" >
                    </Form.Text>
                    <FontAwesomeIcon onClick={onSearchSku}  className='pt-2' style={{height:'25px', paddingLeft :'-25px', position:'absolute' , right :'2px'}} icon={faMagnifyingGlass} />

                </div>                     
                {showDrop && (<SearchDrop myData={myData} show={show} 
                    setClaveProd={setClave} setText={setText}></SearchDrop>)}

 

                        
            </div>
            {/* <div className='col-1 '>
                
                
                <FontAwesomeIcon onClick={onSearchSku}  className='pl-0 pt-2' style={{height:'25px' }} icon={faMagnifyingGlass} />

               
            </div> */}

            
        
        </div>
    
      {/* <Form.Label htmlFor="inputPassword5">Password</Form.Label> */}

    </div>
  )
}
